export const REVIEW_VALIDATION = {
  narrativeMaxLength: 10_000,
  responseMaxLength: 10_000,
  rationaleMaxLength: 10_000,
  messageMaxLength: 2_000,
  requestNoteMaxLength: 2_000,
  fileMaxBytes: 10 * 1024 * 1024,
} as const;

export function isValidMoney(value: number | null): boolean {
  return value === null || (Number.isFinite(value) && value >= 0 && Math.round(value * 100) === value * 100);
}
